import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import StatsStrip from '../components/StatsStrip';
import PartnersAndCustomers from '../components/PartnersAndCustomers';
import GrowthROI from '../components/GrowthROI';
import Fingertips from '../components/Fingertips';
import StateGrid from '../components/StateGrid';
import ProcessSteps from '../components/ProcessSteps';
import DocumentsRequired from '../components/DocumentsRequired';
import GuaranteeCard from '../components/GuaranteeCard';
import Pricing from '../components/Pricing';
import Comparison from '../components/Comparison';
import Reviews from '../components/Reviews';
import FAQ from '../components/FAQ';
import { Enterprise, ContactSection, Footer } from '../components/Footer';

export default function HomePage() {
  useEffect(() => {
    document.title = 'EasyWorks — GST, VPOB & Compliance Services in India';
  }, []);
  return (
    <div className="min-h-screen bg-[#FAF2E8] font-[Inter]">
      <Navbar />
      <Hero />
      <StatsStrip />
      <PartnersAndCustomers />
      <GrowthROI />
      <Fingertips />
      <StateGrid />
      <ProcessSteps />
      <DocumentsRequired />
      <GuaranteeCard />
      <Pricing />
      <Comparison />
      <Reviews />
      <FAQ />
      <Enterprise />
      <ContactSection />
      <Footer />
    </div>
  );
}
